import React from 'react';
import { stats } from '../../data/content';
export function StatsBand() {
  return <section className="bg-navy-800 px-4 py-12 sm:px-6 sm:py-16" data-id="element-230" data-mp="3bvk3vppvfb4b">
      <div className="mx-auto max-w-4xl" data-id="element-231" data-mp="3bxxwzt0zqd98">
        <h2 className="text-center font-display text-[26px] font-bold leading-tight text-white sm:text-4xl" data-id="element-232" data-mp="2y4yl010f316f">
          The visual system to stop searching and start following a{' '}
          <em className="italic text-teal-100" data-id="element-233" data-mp="2o6ir5qa09dt8">clear GLP-1 consultation process</em>
        </h2>

        <dl className="mt-9 grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4" data-id="element-234" data-mp="2t5c33e9n8wra">
          {stats.map(stat => <div key={stat.label} className="flex flex-col rounded-2xl bg-white/[0.07] p-4 text-center ring-1 ring-white/10" data-id="element-235" data-mp="2f62q0ngqiirj">
              <dt className="font-display text-3xl font-bold text-teal-100 sm:text-4xl" data-id="element-236" data-mp="2j8zdosl4t52c">
                {stat.value}
              </dt>
              <dd className="mt-1.5 text-[12px] font-medium leading-snug text-white/75 sm:text-sm" data-id="element-237" data-mp="hg2u2hd5ou6m">
                {stat.label}
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}